/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

type RecentlyCreatedReportEntrypointComponent = EntryPointComponent<{}, {}, {}, {}>;

export const recentlyCreatedReportEntrypoint: EntryPoint<
	RecentlyCreatedReportEntrypointComponent,
	{}
> = createEntryPoint({
	root: JSResourceForUserVisible<RecentlyCreatedReportEntrypointComponent>(
		/* webpackChunkName: "async-reports-recently-created-entrypoint" */ './RecentlyCreatedReportPage.tsx',
		{
			entryFsSsrLiftImportToModule: true,
		},
	),
	getPreloadProps: () => ({}),
});
